import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBag4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconShoppingBag4"><Path fillRule="evenodd" clipRule="evenodd" d="M17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7H3V17.25C3 19.3211 4.67893 21 6.75 21H17.25C19.3211 21 21 19.3211 21 17.25V7H17ZM8.5 7C8.5 5.067 10.067 3.5 12 3.5C13.933 3.5 15.5 5.067 15.5 7H8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShoppingBag4;
